<script setup lang="ts">
import FeedNewsItem from '~/widgets/feed-news-item/ui/FeedNewsItem.vue';
import SpecialProjectFeed from '~/entities/special-project-feed/ui/SpecialProjectFeed.vue';
import type { IFeedDataClientDTO } from '~/shared/api/client/feed/feed.dto';
import type { ISpecialProjectFeedSettingsClientDTO } from '~/shared/api/client/special-project-feed/special-project-feed.dto';
import { buildFeedRenderItems, FEED_BANNER_CONFIG_MAP } from './feedBanners';

const props = defineProps<{
  data?: IFeedDataClientDTO[];
  status?: string;
  specialFeed?: ISpecialProjectFeedSettingsClientDTO;
}>();

const renderedItems = computed(() => buildFeedRenderItems(props.data));

const hasSpecialFeed = computed(() =>
  Boolean(props.specialFeed?.publisher_news?.some((item) => item.news)),
);
</script>

<template>
  <div
    v-if="status === 'success' && ((data && data.length > 0) || hasSpecialFeed)"
    :class="$style.root"
  >
    <SpecialProjectFeed
      v-if="specialFeed && hasSpecialFeed"
      :data="specialFeed"
    />
    <template v-for="item in renderedItems" :key="item.key">
      <FeedNewsItem
        v-if="item.type === 'news'"
        v-bind="item.data.publisher_news[0]!"
        :class="$style.newsItem"
      />
      <Banner
        v-else
        :config="FEED_BANNER_CONFIG_MAP[item.bannerType]"
        :index="item.bannerIndex"
        align="left"
        :width="300"
        show-placeholder
        :placeholder-heights="{ xs: '300/600' }"
      />
    </template>
  </div>
  <div
    v-else-if="
      status === 'error' || (status === 'success' && data && data.length === 0)
    "
    :class="$style.emptyState"
  >
    <p>Не удалось получить новости</p>
    <p>Попробуйте еще раз</p>
  </div>
  <div v-else-if="status === 'pending'">
    <Loader center small />
  </div>
</template>
<style lang="scss" module>
.newsItem {
  padding: var(--space-2-5x);
}

.emptyState {
  text-align: center;
  padding-top: 20px;
  p {
    margin: 10px 0;
  }
}

.banner {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    width: 300px;
    height: 600px;
  }

  & + .newsItem {
    border-top: 1px solid var(--color-gray-line);
  }
}
</style>
